<div class="container" style="display: flex; flex-direction:column; justify-content: space-between; height:90%">

  <h3 i18n class="display-6" align="center" style="padding-top: 10px; color: #005d87; font-weight: bold;">{dialogMode, select, edit {Edit Net} other {Add Net}}</h3>

  <!-- FORM QUESTIONS -->

  <form [formGroup]="netForm">

    <div class="row" style="padding-top: 15px;">

      <h6 i18n class="net-small-header">
              Net Name (for your reference only)
            </h6>
      <mat-form-field appearance="fill">
        <mat-label i18n>Net Name</mat-label>
        <input matInput
          required
          maxlength="30"
          formControlName="netName"
          (input)="sharedMethodsService.forbidWhitespaceOnly('netName', netForm)">
          @if (netForm.invalid) {
            <mat-error i18n>
                Required
              </mat-error>
          }
        </mat-form-field>

      </div>

      <div class="row" style="padding-top: 15px;">

        <h6 i18n class="net-small-header">
              Net Type
            </h6>
        <mat-form-field appearance="fill"
          class="form-field">
          <mat-label i18n>
                  Select
                </mat-label>
          <mat-select formControlName="netType">
            @for (net of netTypes; track net) {
              <mat-option i18n
                [value]="net">
                    {net, select, Alaska Twist {Alaska Twist} Multi Strand {Multi Strand} Combination {Combination}}
                  </mat-option>
            }
          </mat-select>
          @if (netForm.invalid) {
            <mat-error i18n>
                  Required
                </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="row">


        @if (netTypeVal() === 'Alaska Twist') {
          <div
            class="container">
            <h6 i18n class="net-small-header">
                    Number of Strands 
                    </h6>
            <mat-form-field appearance="fill"
              class="form-field">
              <mat-label i18n>
                    Number of Strands
                  </mat-label>
              <input matInput
                inputmode="numeric"
                maxlength="10"
                formControlName="numStrands"
                (input)="sharedMethodsService.forbidNonNumeric('numStrands', netForm)">
                @if (netForm.get('numStrands')?.hasError('required')) {
                  <mat-error i18n>
                    Required
                  </mat-error>
                }
                @if (netForm.get('numStrands')?.hasError('max')) {
                  <mat-error i18n>
                    Value must be less than or equal to 99
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }

        </div>

        <div class="row" style="padding-top: 15px;">

          <h6 i18n class="net-small-header">
              Length (in fathoms)
            </h6>
          <mat-form-field appearance="fill"
            class="form-field">
            <mat-label i18n>
                  Length
                </mat-label>
            <input matInput
              inputmode="numeric"
              maxlength="10"
              formControlName="netLength"
              (input)="sharedMethodsService.forbidNonNumeric('netLength', netForm)">
              @if (netForm.invalid) {
                <mat-error i18n>
                  Required
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="row" style="padding-top: 15px;">

            <div class="col">
              <h6 i18n class="net-small-header">
                Weedline Depth
                </h6>
              <mat-form-field appearance="fill"
                class="form-field">
                <mat-label i18n>
                    Depth
                  </mat-label>
                <input matInput
                  inputmode="numeric"
                  maxlength="10"
                  formControlName="netDepth"
                  (input)="sharedMethodsService.forbidNonNumeric('netDepth', netForm)">
                  @if (netForm.get('netDepth')?.hasError('required')) {
                    <mat-error i18n>
                    Required
                  </mat-error>
                  }
                  @if (netForm.get('netDepth')?.hasError('max')) {
                    <mat-error i18n>
                    Value must be less than or equal to {{netForm.get('netDepth')?.errors?.max.max}}
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col">
                <h6 i18n class="net-small-header">
                    Weedline Depth Units
                  </h6>
                <mat-form-field appearance="fill"
                  class="form-field">
                  <mat-label i18n>
                    Select
                  </mat-label>
                  <mat-select formControlName="netUnits">
                    @for (unit of unitTypes; track unit) {
                      <mat-option
                        [value]="unit">
                        {{unit}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (netForm.invalid) {
                    <mat-error i18n>
                    Required
                  </mat-error>
                  }
                </mat-form-field>
              </div>

            </div>

            <div class="row" style="padding-top: 15px;">

              <h6 i18n class="net-small-header">
              Hang Ratio ( :1)
            </h6>
              <mat-form-field appearance="fill"
                class="form-field">
                <mat-label i18n>
                  Hang Ratio
                </mat-label>
                <input matInput
                  inputmode="numeric"
                  maxlength="10"
                  formControlName="hangRatio"
                  type="number"
                  (input)="limitDecimalPlaces($event)">
                  @if (netForm.invalid) {
                    <mat-error i18n>
                  Required
                </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="row" style="padding-top: 15px;">

                <div class="col">
                  <h6 i18n class="net-small-header">
                Mesh Size (in inches)
                </h6>
                  <mat-form-field appearance="fill"
                    class="form-field">
                    <mat-label i18n>
                    Select
                  </mat-label>
                    <mat-select formControlName="meshSize">
                      @for (digit of meshDigits; track digit) {
                        <mat-option
                          [value]="digit">
                          {{digit}}
                        </mat-option>
                      }
                    </mat-select>
                    @if (netForm.get('meshSize')?.hasError('required')) {
                      <mat-error i18n>
                    Required
                  </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="col">
                  <h6 i18n class="net-small-header">
                    Mesh Size Fraction
                  </h6>
                  <mat-form-field appearance="fill"
                    class="form-field">
                    <mat-label i18n>
                  Select
                </mat-label>
                    <mat-select formControlName="meshSizeFraction">
                      @for (fraction of meshFractions; track fraction) {
                        <mat-option
                          [value]="fraction">
                          {{fraction}}
                        </mat-option>
                      }
                    </mat-select>
                    @if (netForm.invalid) {
                      <mat-error i18n>
                  Required
                </mat-error>
                    }
                  </mat-form-field>
                </div>

              </div>

              <div class="row" style="padding-top: 15px;">

                <h6 i18n class="net-small-header">
              Number of Meshes
            </h6>
                <mat-form-field appearance="fill"
                  class="form-field">
                  <mat-label i18n>
                Number of Meshes
              </mat-label>
                  <input matInput
                    maxlength="3"
                    inputmode="numeric"
                    formControlName="numMeshes"
                    (input)="sharedMethodsService.forbidNonNumeric('numMeshes', netForm)">
                    @if (netForm.get('numMeshes')?.hasError('required')) {
                      <mat-error i18n>
                Required
              </mat-error>
                    }
                    @if (netForm.get('numMeshes')?.hasError('max')) {
                      <mat-error i18n>
                Value must be less than or equal to 99999
              </mat-error>
                    }
                  </mat-form-field>
                </div>

                @if (duplicateFlag) {
                  <h6 i18n class="red-header"
                    >
        Please enter a different net name or type. 
      </h6>
                }

              </form>


              <!-- BACK & ADD BUTTONS -->

              <div class="row">

                <div class="outer">

                  <div class="inner" style="margin-right: 40%">
                    <button i18n mat-stroked-button
                      type="button"
                      aria-label="Back"
                      style="background-color: #005d87; color: white; font-weight: bold;"
                      (click)="deleteNet()">
                  Back
              </button>    
                  </div>


                  <div class="inner">
                    <button i18n mat-stroked-button
                      type="submit"
                      [attr.aria-label]="editNet ? 'Save Net' : 'Add Net'"
                      style="background-color: #ff6f61; color: white; font-weight: bold;"
                      (click)="addNet()">
                  {dialogMode, select, edit {Save} other {Add}}
              </button>
                  </div>

                </div>

              </div>


            </div>

